
import BestGallery from './components/BestGallery';

export default {
  i18nComponentKey: 'WidgetCategoryReviewsBestGallery.WidgetCategoryReviewsBestGalleryPc',
  name: 'WidgetCategoryReviewsBestGalleryPc',
  components: { BestGallery }
};
